import type { Control } from "react-hook-form";
import { t } from "ttag";

import type { BmiForm } from "@/shared/models";
import {
  AnimatedFields,
  Form,
  Input,
  RulerIcon,
  WeigherIcon,
} from "@/shared/ui";

interface MetricFieldsProps {
  control: Control<BmiForm>;
}

export const MetricFields = ({ control }: MetricFieldsProps) => {
  return (
    <AnimatedFields className="sm:grid-cols-2">
      <Form.Field
        control={control}
        name="heightInCentimeters"
        render={() => (
          <Form.Item className="mf-masked mf-listen">
            <Form.Label aria-required>{t`Height (cm)`}</Form.Label>
            <Form.Control>
              <Input.Root
                type="number"
                placeholder={t`E.g. 160`}
                {...control.register("heightInCentimeters", {
                  valueAsNumber: true,
                })}
              >
                <Input.Slot>
                  <RulerIcon />
                </Input.Slot>
              </Input.Root>
            </Form.Control>
            <Form.Message compact={false} />
          </Form.Item>
        )}
      />

      <Form.Field
        control={control}
        name="weightInKilograms"
        render={() => (
          <Form.Item className="mf-masked mf-listen">
            <Form.Label aria-required>{t`Weight (kg)`}</Form.Label>
            <Form.Control>
              <Input.Root
                type="number"
                placeholder={t`E.g. 128`}
                {...control.register("weightInKilograms", {
                  valueAsNumber: true,
                })}
              >
                <Input.Slot>
                  <WeigherIcon />
                </Input.Slot>
              </Input.Root>
            </Form.Control>
            <Form.Message compact={false} />
          </Form.Item>
        )}
      />
    </AnimatedFields>
  );
};
